var map = {
	"./feature_buy_cn.png": 31783,
	"./feature_buy_en.png": 60397,
	"./feature_buy_id.png": 52851,
	"./feature_buy_ko.png": 51494,
	"./feature_buy_th.png": 97600,
	"./feature_buy_zh.png": 88958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12847;